import { useEffect, useState } from 'react';
import StageDetail from '../components/StageDetail';
import axiosInstance from "../helpers/Axios";
// import {Stages as ListeStages} from '../constants/Stages';
import type { IStage } from '../interfaces/IStage';


const defaultList: IStage[] = []
// ({shortName:"", name:"Choisir votre stage", description: "choix", startDate:'2024-08-13', endDate:'2024-08-15', startTime:'08:00:00', endTime:'16:00:00'}),
// ({shortName:"2", name:"F", description: "ff", startDate:'2024-08-16', endDate:'2024-08-18', startTime:'08:00:00', endTime:'16:00:00'}),
// ({shortName:"3", name:"G", description: "gg", startDate:'2024-08-19', endDate:'2024-08-22', startTime:'08:00:00', endTime:'16:00:00'})];

// interface IStage {
//   shortName: string;
//   name: string;
//   description: string;
//   startDate: string;
//   endDate: string;
//   startTime: string;
//   endTime: string;
// }

interface IStageObj {
  stage: IStage;
}

const Stages = () => {

  const [list, setList] = useState(defaultList);
  const [visible, setVisible] = useState(true);
  const loading = list === defaultList && visible;

  useEffect(() => {
    if (loading)
      axiosInstance.get("/stage")
        .then(response => {
          // console.log('response', response);

          setList(response.data.map((stageObj: IStageObj) => stageObj.stage).filter((stage: IStage) => stage.isVisible));
          // setUserProfile(response.data);
          // setLocation(response.data.location);
        })
        .catch((err) => {
          const error = err.response === undefined ?
            'Server in not reachable'
            : err.response.data;
          console.log('error', error);
          setVisible(false);
        });
  }
  );

  return (
    <div id="stages">
      <div id="title">
        <h1>Stages<br /> Weekends</h1>
      </div>
      <div id="content">
        {loading ?
          <p>Chargement en cours...</p>
          :
          visible ?
            <div className="flex flex-wrap flex-space-between">
              {/* {ListeStages.length > 0 ? ListeStages.map((stage) => {
                return <StageDetail stage={stage} />
              })
              : <div>
                  <p>Aucun stage n'est programmé pour le moment.</p>
                </div>
              } */}
              {list.length > 0 ? list.map((stage) => {
                return <StageDetail key={stage.shortName} stage={stage} />
              })
              : <div>
                  <p>Aucun stage n'est programmé pour le moment.</p>
                </div>
              }
            </div>
            :
            <div>
              <p>Le système d'inscription est actuellement en panne.</p>
            </div>
        }
      </div>
    </div>
  )
};

export default Stages;
